<template lang="pug">
  .search-input-wrapper.d-flex.align-items-center.w-100
    a.search-trigger(href="#" @click.prevent="toggleOpen")
      i.fa.fa-fw.d-none.d-md-block(:class="openOrNotEmpty ? 'fa-times' : 'fa-search'")
      i.fa.fa-fw.fa-search.d-md-none.mr-1

    .search-input-container(:class="{ open: openOrNotEmpty }")
      i.fa.fa-spinner.fa-pulse.animated(v-show="throttling")
      input.form-control.search-input(
        ref="inputRef"
        v-model="realtimeValue"
        placeholder="поиск..."
        maxlength="32"
      )
</template>

<script>
  import { ref, computed, watch } from '@vue/composition-api';
  import { throttle } from 'underscore';

  export default {
    props: {
      value: {
        type: String,
        default: '',
      },
    },

    setup (props, { emit, root }) {
      const throttlingRef = ref(false);
      const openRef = ref(false);
      const inputRef = ref(null);
      const realtimeValueRef = ref(props.value);

      const throttledEmit = throttle(value => {
        emit('input', value);
        throttlingRef.value = false;
      }, 500, { leading: false });

      watch(realtimeValueRef, value => {
        throttlingRef.value = true;
        throttledEmit(value);
      }, { immediate: true });

      return {
        inputRef,
        throttling: throttlingRef,
        openOrNotEmpty: computed(() => realtimeValueRef.value || openRef.value),
        realtimeValue: realtimeValueRef,
        toggleOpen () {
          if (openRef.value) {
            realtimeValueRef.value = '';
          } else {
            root.$nextTick(() => inputRef.value.focus());
          }

          openRef.value = !openRef.value;
        },
      };
    },
  };
</script>

<style lang="scss" scoped>
  .search-trigger {
    color: $boulder !important;

    @include media-breakpoint-down(sm) {
      display: block !important;
    }

    &:hover, &:active {
      color: $scorpion !important;
    }
  }

  .search-input-container {
    width: 0;
    overflow: hidden;
    position: relative;
    transition: width .25s ease-out;

    @include media-breakpoint-down(sm) {
      width: auto;
      flex: 1 1 auto;
    }

    @include media-breakpoint-up(md) {
      &.open {
        width: 200px;
      }
    }

    .fa-spinner {
      position: absolute;
      top: 9px;
      bottom: auto;
      right: 6px;
    }

    .search-input {
      width: 100%;
      max-height: 34px;
      padding: 4px 8px;
    }
  }
</style>
